import React, { Suspense, useEffect } from "react";
import { useIntl } from "react-intl";
import { downloadFile } from "../../../util";
import { FileDescriptor } from "../../../../cuba/entities/base/sys$FileDescriptor";
import { ButtonComponent, ModalWithPortalComponent, useModal } from "../../../shared";
import { Text } from "../../../shared/ui/text";
import { DownloadIcon } from "../../../../resources/icons/interface";
import { CenteredLoader } from "../../../CenteredLoader";

const PdfViewer = React.lazy(() =>
  import("../../../features/pdf-viewer/pdf-viewer")
);

type PdfPreviewProps = {
  file: any;
  setOpen: (open: () => void) => void;
}

export const PdfPreviewModal = (props: PdfPreviewProps) => {
  const { openModal, onOpen, onClose } = useModal();
  const intl = useIntl();

  const { file, setOpen } = props;

  const handleDownLoadFile = () => {
    downloadFile(
      (file as FileDescriptor).id,
      (file as FileDescriptor).name as string,
      (file as FileDescriptor).extension as string,
      intl.formatMessage({ id: "file.download.error" }),
    );
  };

  useEffect(() => {
    setOpen(onOpen);
  }, []);
  return (
    <>
      {
        openModal && (
          <ModalWithPortalComponent
            isPriorityHeader={false}
            isFull
            onClose={onClose}
            withoutButton
          >
            <div className="flex flex-col h-full">
              {/* Заголовок */}
              <Text className="mb-4" type="headline2" weight="500">
                {file?.name}
              </Text>

              {/* Контейнер для PDF: занимает всё доступное место, но не больше 80% */}
              <div className="flex-1 flex justify-center overflow-hidden">
                <div className="w-full h-full overflow-y-hidden border border-gray-300 rounded">
                  <Suspense fallback={<CenteredLoader />}>
                    <PdfViewer fileId={file.id} fileExtension={file.extension as string} />
                  </Suspense>
                </div>
              </div>

              {/* Футер с кнопками */}
              <div className="flex justify-end gap-4 mt-6 shrink-0">
                <ButtonComponent
                  className="p-2 bg-inherit text-primary-active border border-primary-active gap-2"
                  onClick={handleDownLoadFile}
                >
                  <DownloadIcon className="w-5" />
                  {intl.formatMessage({ id: "download" })}
                </ButtonComponent>
              </div>
            </div>
          </ModalWithPortalComponent>


        )
      }
    </>
  );
};
